<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-button 
      v-if="method != 'add'"
      size="medium" class="mb8"
      :icon="method == 'view' ? 'el-icon-edit' :''"
      :type="method == 'view' ? 'warning' :'primary'"  :plain="method == 'view' ? false : true"
      @click="handEditorView(method)" :disabled="!hasPermission('ummcolumn:hearderLayout:edit')">
        {{ method == 'view' ? '编辑' : '取消'}}
      </el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  >
        <el-col :span="12">
            <el-form-item label="名称" prop="name"
                :rules="[
                  {required: true, message:'名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.name" placeholder="请填写名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文值" prop="valEn"
                :rules="[
                  {required: true, message:'英文值不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.valEn" placeholder="请填写英文值"  maxlength="255"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文值" prop="valCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.valCn" placeholder="请填写中文值"  maxlength="255"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="父栏目" prop="parentId"
                :rules="[
                  {required: true, message:'父栏目不能为空', trigger:'blur'}
                 ]">
                <!-- <el-select v-model="inputForm.parentId" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in parentIdOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select> -->
              <SelectTree 
                ref="menuParentTree"
                :props="{
                    value: 'id',             // ID字段名
                    label: 'name',         // 显示名称
                    children: 'children'    // 子级字段名
                  }"
                :data="parentIdOption"
                :value="inputForm.parentId"
                :clearable="true" 
                :accordion="true"
                @getValue="handSelectTree"/>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="链接或路由" prop="url"
                :rules="[
                  {required: true, message:'链接或路由不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.url" placeholder="请填写链接或路由"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="排序" prop="sort"
                :rules="[
                  {required: true, message:'排序不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.sort" placeholder="请填写排序"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="状态" prop="state"
                :rules="[
                  {required: true, message:'状态不能为空', trigger:'blur'}
                 ]">
                <el-select v-model="inputForm.state" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in $dictUtils.getDictList('show_hide')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                      </el-select>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" type="danger"  icon="el-icon-close" @click="visible = false">关闭</el-button>
      <el-button size="medium" type="success" icon="el-icon-check" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import hearderLayoutService from '@/api/ummcolumn/hearderLayoutService'
  import SelectTree from '@/components/treeSelect/treeSelect.vue'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          name: '',
          valEn: '',
          valCn: '',
          parentId: '',
          url: '',
          sort: '',
          state: ''
        },
        parentIdOption: [],
        testID: '0'
      }
    },
    components: {
      SelectTree
    },
    activated () {
    },
    methods: {
      handSelectTree (e) {
        this.inputForm.parentId = e
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      // 获取数据列表
      async refreshList () {
        this.loading = true
        await hearderLayoutService.list({
          'current': '1',
          'size': '100'
        }).then(({data}) => {
          if (!data) return
          let mapList = data.records.filter(item => item.parentId === '0').map(mitem => {
            return { id: mitem.id, name: mitem.valCn }
          })
          // mapList.unshift({ value: '0', label: '顶层' })
          let setOptionList = [
            {id: '0', name: 'UnitModeler', children: mapList}
          ]
          this.parentIdOption = setOptionList
        })
      },
      init (method, obj) {
        this.method = method
        this.inputForm.id = obj.id
        if (method === 'add') {
          this.title = `新建栏目管理`
        } else if (method === 'edit') {
          this.title = '修改栏目管理'
        } else if (method === 'view') {
          this.title = '查看栏目管理'
        }
        this.loading = false
        hearderLayoutService.list({
          'current': '1',
          'size': '100'
        }).then(({data}) => {
          if (!data) return
          let mapList = data.records.filter(item => item.parentId === '0').map(mitem => {
            return { id: mitem.id, name: mitem.valCn }
          })
          // mapList.unshift({ value: '0', label: '顶层' })
          let setOptionList = [
            {id: '0', name: 'UnitModeler', children: mapList}
          ]
          this.parentIdOption = setOptionList
        }).then(() => {
          this.visible = true
          this.$nextTick(() => {
            this.$refs.menuParentTree.clearHandle()
            this.$refs['inputForm'].resetFields()
            this.inputForm.parentId = obj.parent
          })
        }).then(() => {
          this.$nextTick(() => {
            if (method === 'edit' || method === 'view') { // 修改或者查看
              this.loading = true
              hearderLayoutService.queryById(this.inputForm.id).then(({data}) => {
                this.inputForm = this.recover(this.inputForm, data)
                this.loading = false
              })
            }
          })
        })
      },
      // 表单提交
      doSubmit () {
        let userObj = JSON.parse(localStorage.getItem('user'))
        this.inputForm.author = userObj.name
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            hearderLayoutService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
</style>
  
